"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactSelect = _interopRequireDefault(require("react-select"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DetectMobile = require('detect-mobile-browser')(false);
if (typeof window !== 'function' && typeof window !== 'object') {
  DetectMobile.setUserAgent('');
}
const isMobile = DetectMobile.isAny();
const StyledSelect = (0, _styledComponents.default)(_reactSelect.default)`
  // prevent input boxes from showing through the dropdowns
  .Select-menu-outer {
    z-index: 1000;

    // CONTROLLED BY '.Select-menu'
    max-height: 1000px;
  }

  // use shadow to indicate when there are more options if
  // you scroll
  .Select-menu {
    background: linear-gradient(white 17%, rgba(255, 255, 255, 0)),
      linear-gradient(rgba(255, 255, 255, 0), white 83%) 0 100%,
      linear-gradient(rgba(0, 0, 0, 0.13), rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0)),
      linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0.13)) 0 100%;
    background-repeat: no-repeat;
    background-color: white;
    background-size: 100% 90px, 100% 90px, 100% 14px, 100% 14px;

    /* Opera doesn't support this in the shorthand */
    background-attachment: local, local, scroll, scroll;

    max-height: 220px;
  }
  .Select-option {
    background: none;
  }
`;
const NativeSelectContainer = _styledComponents.default.div`
  position: relative;
  &::after {
    content: ' ';
    pointer-events: none;
    display: block;
    border-color: hsl(0, 0%, 60%) hsla(0, 0%, 0%, 0) hsla(0, 0%, 0%, 0);
    border-style: solid;
    border-width: 5px 5px 2.5px;
    display: inline-block;
    height: 0;
    width: 0;
    position: absolute;
    top: 17px;
    right: 10px;
  }
`;
const NativeSelect = _styledComponents.default.select`
  appearance: none;
  display: block;
  width: 100%;
  font-size: 1rem;
  line-height: 1.25;
  color: hsl(200, 4%, 29%);
  background: white;
  border: 1px solid hsla(0, 0%, 0%, 0.15);
  border-radius: 0.25rem;
  height: 36px;
  padding: 0.5rem 0.75rem;
`;
class _Class extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_checkMatch", props => {
      if (props.value && !props.isLoading && props.options && !props.options.some(option => option.value === props.value)) {
        if (props.onChange && !props.multi) {
          props.onChange(null);
        }
        return !!props.multi;
      }
      return true;
    });
    _defineProperty(this, "_onChange", options => {
      if (this.props.multi) {
        const optionsArray = [];
        for (const o of options) {
          optionsArray.push(o.value);
        }
        this.props.onChange(optionsArray);
      } else {
        this.props.onChange(options ? options.value : null);
      }
    });
    _defineProperty(this, "_onMobileChange", e => {
      const v = +e.target.value;
      this.props.onChange(v === -1 ? null : this.props.options[v] ? this.props.options[v].value : null);
    });
  }
  componentDidMount() {
    this._checkMatch(this.props);
    if (typeof window !== 'undefined' && this.props['data-test-id']) {
      window.selects = window.selects || {};
      const selects = window.selects;
      selects[this.props['data-test-id']] = this;
    }
  }
  componentWillUnmount() {
    if (typeof window !== 'undefined' && this.props['data-test-id']) {
      const selects = window.selects;
      delete selects[this.props['data-test-id']];
    }
  }
  componentWillUpdate(nextProps) {
    this._checkMatch(nextProps);
  }
  render() {
    if (isMobile && !this.props.multi && !this.props.clearable && !this.props.isLoading && !this.props.disabled && this._checkMatch(this.props)) {
      const options = this.props.options;
      const value = this.props.value;
      const isNull = !options.some(o => o.value === value);
      return /*#__PURE__*/_react.default.createElement(NativeSelectContainer, null, /*#__PURE__*/_react.default.createElement(NativeSelect, {
        onChange: this._onMobileChange
      }, value ? null : /*#__PURE__*/_react.default.createElement("option", {
        value: "-1",
        selected: isNull
      }, this.props.placeholder || 'Select a value...'), (this.props.options || []).map((option, i) => /*#__PURE__*/_react.default.createElement("option", {
        key: i,
        value: i,
        selected: value === option.value
      }, option.label))));
    }
    return /*#__PURE__*/_react.default.createElement(StyledSelect, _extends({}, this.props, {
      matchProp: this.props.matchProp || 'label',
      onChange: this._onChange
    }));
  }
}
exports.default = _Class;
_defineProperty(_Class, "propTypes", _reactSelect.default.propTypes);